var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React, { useState } from "react";
import { Pane, PaneFooter, Button, Row, Col, ErrorModal, AccordionSet, Accordion, } from "@folio/stripes/components";
import { useIntl, FormattedMessage } from "react-intl";
import { useForm, Controller } from "react-hook-form";
import { RecekNumberField, RecekTextField } from "../../components/inputs";
import { RecekPaneSet } from "../../components/RecekPaneSet";
import { toErrorWithResponse } from "../../utils/httpErrors";
import { useScrollToError } from "../../hooks/useScrollToError";
var OnixCodetablesForm = function (_a) {
    var initialValues = _a.initialValues, onSubmit = _a.onSubmit, title = _a.title, onCancel = _a.onCancel;
    var formatMessage = useIntl().formatMessage;
    var _b = useState(false), errorModalOpen = _b[0], setErrorModalOpen = _b[1];
    var _c = useState(""), errorMessage = _c[0], setErrorMessage = _c[1];
    var _d = useState({
        number: true,
        name: true,
    }), accordionStatus = _d[0], setAccordionStatus = _d[1];
    var _e = useState(true), expandAll = _e[0], setExpandAll = _e[1];
    var _f = useForm({
        defaultValues: __assign({ number: undefined, name: "", version: undefined }, initialValues),
        mode: "onBlur",
    }), handleSubmit = _f.handleSubmit, control = _f.control, _g = _f.formState, errors = _g.errors, isSubmitting = _g.isSubmitting;
    useScrollToError(errors);
    var handleError = function (caught) { return __awaiter(void 0, void 0, void 0, function () {
        var error, status, body, resp, _a, _b, _c, _d, errs, isDuplicate;
        var _e, _f;
        return __generator(this, function (_g) {
            switch (_g.label) {
                case 0:
                    error = toErrorWithResponse(caught);
                    status = (_f = (_e = error === null || error === void 0 ? void 0 : error.response) === null || _e === void 0 ? void 0 : _e.status) !== null && _f !== void 0 ? _f : error === null || error === void 0 ? void 0 : error.status;
                    if (!(error === null || error === void 0 ? void 0 : error.response)) return [3 /*break*/, 8];
                    _g.label = 1;
                case 1:
                    _g.trys.push([1, 3, , 8]);
                    resp = error.response.clone
                        ? error.response.clone()
                        : error.response;
                    return [4 /*yield*/, resp.json()];
                case 2:
                    body = _g.sent();
                    return [3 /*break*/, 8];
                case 3:
                    _a = _g.sent();
                    _g.label = 4;
                case 4:
                    _g.trys.push([4, 6, , 7]);
                    _c = (_b = JSON).parse;
                    return [4 /*yield*/, error.response.text()];
                case 5:
                    body = _c.apply(_b, [_g.sent()]);
                    return [3 /*break*/, 7];
                case 6:
                    _d = _g.sent();
                    body = undefined;
                    return [3 /*break*/, 7];
                case 7: return [3 /*break*/, 8];
                case 8:
                    if (status === 422) {
                        errs = Array.isArray(body === null || body === void 0 ? void 0 : body.errors) ? body.errors : [];
                        isDuplicate = errs.some(function (e) {
                            return String(e === null || e === void 0 ? void 0 : e.type) === "-1" ||
                                (e === null || e === void 0 ? void 0 : e.code) === "VALIDATION_ERROR" ||
                                /already exists/i.test((e === null || e === void 0 ? void 0 : e.message) || "");
                        });
                        if (isDuplicate) {
                            setErrorMessage(formatMessage({
                                id: "ui-br-agency.onix-codetables.error.message.duplicate",
                            }));
                            setErrorModalOpen(true);
                            return [2 /*return*/];
                        }
                    }
                    setErrorMessage(formatMessage({ id: "ui-br-agency.onix-codetables.error.submit" }));
                    setErrorModalOpen(true);
                    return [2 /*return*/];
            }
        });
    }); };
    var submit = function (data) { return __awaiter(void 0, void 0, void 0, function () {
        var error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, onSubmit(data)];
                case 1:
                    _a.sent();
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    handleError(error_1);
                    setErrorModalOpen(true);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    var toggleExpandCollapseAll = function () {
        setAccordionStatus({
            number: !expandAll,
            name: !expandAll,
        });
        setExpandAll(!expandAll);
    };
    return (React.createElement(RecekPaneSet, null,
        React.createElement(Pane, { id: "contentPane", defaultWidth: "fill", paneTitle: title, footer: React.createElement(PaneFooter, { renderStart: React.createElement(Button, { type: "submit", buttonStyle: "primary", marginBottom0: true, disabled: isSubmitting, onClick: handleSubmit(submit) },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.button.save" })), renderEnd: React.createElement(Button, { buttonStyle: "default", onClick: onCancel, marginBottom0: true },
                    React.createElement(FormattedMessage, { id: "ui-br-agency.button.cancel" })) }) },
            React.createElement(ErrorModal, { open: errorModalOpen, label: formatMessage({
                    id: "ui-br-agency.modal.label.error",
                }), content: errorMessage, onClose: function () { return setErrorModalOpen(false); } }),
            React.createElement(Row, null,
                React.createElement(Col, { xs: 12, style: { display: "flex", justifyContent: "flex-end" } },
                    React.createElement(Button, { onClick: toggleExpandCollapseAll, buttonStyle: "default" }, expandAll
                        ? formatMessage({ id: "ui-br-agency.button.collapse" })
                        : formatMessage({ id: "ui-br-agency.button.expand" })))),
            React.createElement("form", { noValidate: true, onSubmit: handleSubmit(submit) },
                React.createElement(AccordionSet, null,
                    React.createElement(Accordion, { id: "number", label: formatMessage({
                            id: "ui-br-agency.onix-codetables.form.section.number",
                        }), open: accordionStatus.number, onToggle: function () {
                            return setAccordionStatus(__assign(__assign({}, accordionStatus), { number: !accordionStatus.number }));
                        } },
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(Controller, { control: control, name: "number", rules: {
                                        required: true,
                                        validate: function (v) { return !Number.isNaN(v); },
                                    }, render: function (_a) {
                                        var field = _a.field;
                                        return (React.createElement(RecekNumberField, __assign({}, field, { labelId: "ui-br-agency.onix-codetables.form.number.label", required: true, error: errors.number
                                                ? formatMessage({
                                                    id: "stripes-core.label.missingRequiredField",
                                                })
                                                : undefined })));
                                    } })))),
                    React.createElement(Accordion, { id: "name", label: formatMessage({
                            id: "ui-br-agency.onix-codetables.form.section.name",
                        }), open: accordionStatus.name, onToggle: function () {
                            return setAccordionStatus(__assign(__assign({}, accordionStatus), { name: !accordionStatus.name }));
                        } },
                        React.createElement(Row, null,
                            React.createElement(Col, { xs: 12, md: 6 },
                                React.createElement(Controller, { control: control, name: "name", rules: { required: true }, render: function (_a) {
                                        var field = _a.field;
                                        return (React.createElement(RecekTextField, __assign({}, field, { labelId: "ui-br-agency.onix-codetables.form.name.label", required: true, error: errors.name
                                                ? formatMessage({
                                                    id: "stripes-core.label.missingRequiredField",
                                                })
                                                : undefined })));
                                    } })))))))));
};
export default OnixCodetablesForm;
